export default "__VITE_ASSET__9SviTXwI__"